import "./spinner.scss";
import { ProgressSpinner } from 'primereact/progressspinner';

const Spinner = () => {
  return (
    <div className="fp-container">
      {/* <ProgressSpinner style={{ width: '50px', height: '50px' }} className="fp-loader" strokeWidth="3" animationDuration="1s" />
      <p className="fp-text">Please wait...</p> */}

      <i className="fa fa-spinner fa-pulse fa-3x fa-fw fp-loader"></i>
      <span className="fp-text">Please wait...</span>
    </div>
  )
}

export default Spinner;